import { render, staticRenderFns } from "./MemberBox.vue?vue&type=template&id=45a98983&"
import script from "./MemberBox.vue?vue&type=script&lang=ts&"
export * from "./MemberBox.vue?vue&type=script&lang=ts&"
import style0 from "./MemberBox.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports